import React, { useRef } from 'react';
import { useTooltipPosition } from '../hooks/useTooltipPossition/useTooltipPossition';
import { classes, st } from './style/Tooltip.component.st.css';

const ARROW_SIZE = 10;

export const Tooltip = ({
  tooltipId,
  children,
  dataTestId,
  iconComponent: IconComponent,
}: {
  children: React.ReactNode;
  dataTestId?: string;
  iconComponent?: React.ElementType;
  tooltipId: string;
}) => {
  const tooltipRef = useRef<HTMLDivElement>(null);
  const { tooltipTopPosition } = useTooltipPosition({
    arrowSize: ARROW_SIZE,
    tooltipRef,
  });

  return (
    <div id={tooltipId} className={st(classes.tooltipWrapper)}>
      <div
        role="tooltip"
        className={st(classes.tooltip)}
        style={{ top: `-${tooltipTopPosition}px` }}
        ref={tooltipRef}
        data-testid={dataTestId}
      >
        <span>{children}</span>
        <span className={st(classes.tooltipArrow)} />
      </div>
      {IconComponent && <IconComponent />}
    </div>
  );
};
